document.querySelectorAll('.hh-quiz').forEach((root) => {
  const start = root.querySelector('.hh-start-quiz');
  const intro = root.querySelector('.hh-quiz-intro');
  const flow = root.querySelector('.hh-quiz-flow');
  const panels = [...root.querySelectorAll('.hh-quiz-panel')];
  const back = root.querySelector('.hh-quiz-back');
  const results = root.querySelector('.hh-quiz-results');
  const counter = root.querySelector('.hh-progress-label');
  const bar = root.querySelector('.hh-progress-track span');
  let step = 0;
  const selected = ['', '', ''];
  function show() {
    panels.forEach((p, i) => { p.hidden = i !== step; });
    counter.textContent = `${step + 1} / 3`;
    bar.style.width = `${((step + 1) / 3) * 100}%`;
    back.hidden = step === 0;
    results.hidden = step !== 2;
  }
  start.addEventListener('click', () => { intro.hidden = true; flow.hidden = false; show(); });
  panels.forEach((panel, i) => panel.querySelectorAll('button[data-value]').forEach((button) => {
    button.addEventListener('click', () => {
      selected[i] = button.dataset.value;
      panel.querySelectorAll('button[data-value]').forEach((b) => b.classList.toggle('is-selected', b === button));
      if (step < 2) { step++; show(); }
    });
  }));
  back.addEventListener('click', () => { if (step > 0) { step--; show(); } else { flow.hidden = true; intro.hidden = false; } });
  results.addEventListener('click', () => {
    // Shopify product-tag collection URLs: multiple tags are intersected (AND).
    // Existing CSV applies all four room tags to every product; room selection is informational until tags are refined.
    const tags = selected.filter(Boolean);
    const url = '/collections/all' + (tags.length ? '/' + tags.map(encodeURIComponent).join('+') : '');
    window.location.assign(url);
  });
});
